import type { DepartmentCode, AppState } from './types';

export const CONFIG = {
  dataUrl: 'https://raw.githubusercontent.com/caticoa3/colombia_mapa/master/co_2018_MGN_MPIO_POLITICO.geojson',
  mapWidth: 800,
  mapHeight: 600,
  mapMargin: 40,
  departmentCodes: [
    { code: '91', name: 'Amazonas' },
  { code: '05', name: 'Antioquia' },
  { code: '81', name: 'Arauca' },
  { code: '08', name: 'Atlántico' },
  { code: '11', name: 'Bogotá D.C.' },
  { code: '13', name: 'Bolívar' },
  { code: '15', name: 'Boyacá' },
  { code: '17', name: 'Caldas' },
  { code: '18', name: 'Caquetá' },
  { code: '85', name: 'Casanare' },
  { code: '19', name: 'Cauca' },
  { code: '20', name: 'Cesar' },
  { code: '27', name: 'Chocó' },
  { code: '23', name: 'Córdoba' },
  { code: '25', name: 'Cundinamarca' },
  { code: '94', name: 'Guainía' },
  { code: '95', name: 'Guaviare' },
  { code: '41', name: 'Huila' },
  { code: '44', name: 'La Guajira' },
  { code: '47', name: 'Magdalena' },
  { code: '50', name: 'Meta' },
  { code: '52', name: 'Nariño' },
  { code: '54', name: 'Norte de Santander' },
  { code: '86', name: 'Putumayo' },
  { code: '63', name: 'Quindío' },
  { code: '66', name: 'Risaralda' },
  { code: '88', name: 'San Andrés, Providencia y Santa Catalina' },
  { code: '68', name: 'Santander' },
  { code: '70', name: 'Sucre' },
  { code: '73', name: 'Tolima' },
  { code: '76', name: 'Valle del Cauca' },
  { code: '97', name: 'Vaupés' },
  { code: '99', name: 'Vichada' }
  ] as DepartmentCode[],
  colors: {
    fill: '#6f9c76',
    stroke: '#ffffff',
    strokeWidth: '0.5'
  }
};

export const STATE: AppState = {
  currentFeatures: [],
  allData: {
    departamentos: null,
    municipios: null
  },
  displayOption: 'map',
  isAllDepartments: false,
  jsonGenerated: {
    departamento: false,
    all: false
  }
};
